import { render } from "./ChristmasOfferGoal.vue?vue&type=template&id=6741515b&scoped=true"
import script from "./ChristmasOfferGoal.vue?vue&type=script&lang=js"
export * from "./ChristmasOfferGoal.vue?vue&type=script&lang=js"

import "./ChristmasOfferGoal.vue?vue&type=style&index=0&id=6741515b&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6741515b"],['__file',"src/components/christmas-offer/ChristmasOfferGoal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6741515b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6741515b', __exports__)) {
    console.log('reload')
    api.reload('6741515b', __exports__)
  }
  
  module.hot.accept("./ChristmasOfferGoal.vue?vue&type=template&id=6741515b&scoped=true", () => {
    console.log('re-render')
    api.rerender('6741515b', render)
  })

}


export default __exports__